import styled from '@emotion/styled';

const Card = styled.div`
  box-shadow: 0px 3px 6px #00000029;
  background-color: #fff;
`;

export default Card;
